import { createFileRoute } from "@tanstack/react-router";
import { CategoryForm } from "@/components/admin/category-form";

export const Route = createFileRoute("/admin/categorias/novo")({
  component: NovaCategoriaPage,
});

function NovaCategoriaPage() {
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-eg-dark mb-6">Nova Categoria</h1>
      <CategoryForm />
    </div>
  );
}
